import ApisServiceApp from '@api/ApisServiceApp'
import { ICustomer } from '@interfaces/customerInterfaces'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

export function createCustomer(data: ICustomer) {
  try {
    return ApisServiceApp.post('/customer/create-customer', data)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function updateCustomer(data: ICustomer) {
  try {
    return ApisServiceApp.put('/customer/' + data.id + '/update-customer', data)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function getDetailCustomer(id: string) {
  try {
    return ApisServiceApp.get('/customer/' + id + '/get-chitiet-customer')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function getListCustomer(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/customer/filter-customer', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}


export function getListOptionCustomer(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return ApisServiceApp.get('/customer/filter-customer', {
      params: query || {},
    })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteCustomer(id: string) {
  try {
    return ApisServiceApp.delete('/customer/' + id + '/delete-customer')
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function deleteMultiCustomer(idArr: Array<string>) {
  try {
    return ApisServiceApp.delete('/customer/bulk-delete-customer', { data: idArr })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
